import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

/**
 * Sprint 5b.1.6 A.2 — filtre période sur la page « Opportunités suggérées ».
 *
 * 3 valeurs : 7 / 14 / 30 jours. Défaut 7 (aligné fenêtre cron). 14 / 30 utiles
 * après un congé ou un week-end prolongé pour remonter manuellement plus loin.
 */

const PERIOD_OPTIONS: { value: 7 | 14 | 30; label: string }[] = [
  { value: 7, label: '7 derniers jours' },
  { value: 14, label: '14 derniers jours' },
  { value: 30, label: '30 derniers jours' },
];

interface PeriodFilterProps {
  value: 7 | 14 | 30;
  onChange: (value: 7 | 14 | 30) => void;
}

export function PeriodFilter({ value, onChange }: PeriodFilterProps) {
  return (
    <Select
      value={String(value)}
      onValueChange={(v) => onChange(Number(v) as 7 | 14 | 30)}
    >
      <SelectTrigger className="h-9 w-[180px] text-sm">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {PERIOD_OPTIONS.map((opt) => (
          <SelectItem key={opt.value} value={String(opt.value)}>
            {opt.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
